import { Flex, Stack } from '@chakra-ui/react'

import TextWithLines from '@/components/TextWithLines/TextWithLines'
import Alert, { type AlertVariant } from '@/components/UI/Alert'

import CTAButton from './CTAButton/CTAButton'
import type { CTA } from './CTAButton/types'

export type AlertWithCTAProps = {
  text: string
  cta?: CTA
  variant: AlertVariant
}

export default function AlertWithCTA({
  text,
  cta,
  variant = 'warning',
}: AlertWithCTAProps): JSX.Element {
  return (
    <Alert variant={variant} my="16px">
      <Stack
        direction={['column', 'column', 'row']}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="column">
          <TextWithLines text={text} fontWeight="bold" />
        </Stack>
        {cta != null ? (
          <Flex width={['100%', '100%', 'auto']} pt={[4, 4, 0]}>
            <CTAButton {...cta} />
          </Flex>
        ) : null}
      </Stack>
    </Alert>
  )
}
